// extracted by mini-css-extract-plugin
module.exports = {"eventName":"EventName_eventName__3KzD-"};